<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        small
        :disabled="!promotion.isReallyActive"
      >
        <v-icon>mdi-pencil</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-form v-model="validForm" @submit="updatePromotion">
        <v-toolbar flat tile class="flex-grow-0">
          <v-toolbar-title class="title">
            {{ $t("updatingPromotion") }}
          </v-toolbar-title>
          <div class="flex-grow-1"></div>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="pa-4 px-6">
            <v-text-field
              :label="$t('title')"
              v-model="newPromotion.title"
              :rules="[rules.required]"
              clearable
              outlined
              dense
              autocapitalize="off"
              :counter="40"
              maxlength="40"
            ></v-text-field>
            <v-text-field
              :label="$t('description')"
              v-model="newPromotion.description"
              :rules="[rules.required]"
              clearable
              outlined
              dense
              autocapitalize="off"
              :counter="50"
              maxlength="50"
            ></v-text-field>
          </div>

          <div v-if="shouldHidePromotion">
            <v-subheader class="overline pt-4">
              {{ $t("promotionVisibility") }}
            </v-subheader>
            <div class="pa-4 px-6 d-flex align-center">
              <v-switch
                v-model="newPromotion.hidePromotion"
                :label="$t('hidePromotion')"
                class="pr-2"
              >
              </v-switch>
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon color="primary" v-on="on" v-bind="attrs">
                    mdi-information-outline
                  </v-icon>
                </template>
                <div style="max-width: 320px">
                  {{ $t("hidePromotionTooltip", { updateMessage: "" }) }}
                </div>
              </v-tooltip>
            </div>
          </div>

          <v-subheader class="overline">
            {{ $t("promotionImageWithoutAsterisk") }}
          </v-subheader>
          <div
            class="pb-4 pt-2"
            :class="$vuetify.breakpoint.mobile ? 'mx-6' : 'mx-8'"
          >
            <div v-if="imageLoaded === false">
              <v-skeleton-loader type="image" />
            </div>
            <img
              class="mx-auto"
              width="100%"
              style="max-width: 400px"
              :src="currentImage"
              @load="imageLoaded = true"
            />
          </div>
          <div class="px-6 mt-0 pt-2">
            <p class="caption grey--text">
              {{ $t("recommendedImagiSizePromoImage") }}
            </p>
            <p class="caption grey--text mt-0 pt-0">
              {{ $t("browserCachingImage") }}
              <a
                target="_blank"
                :href="`${operatorUrl}/promotions/${this.promotion.id_promo}`"
              >
                {{ $t("promotionLink") }}
              </a>
            </p>

            <v-file-input
              dense
              outlined
              @click.prevent="loadImage"
              :label="$t('loadImage')"
            />

            <v-spacer />

            <input
              ref="image"
              id="imgInput"
              class="pb-6"
              type="file"
              @change="onFileChange"
            />
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <v-btn @click.prevent="deleteImage">
            Deletar
          </v-btn> -->
          <v-btn
            type="submit"
            @click.prevent="dialog = false"
            :loading="loading"
            :disabled="loading"
          >
            {{ $t("toCancel") }}
          </v-btn>
          <v-btn
            color="primary"
            type="submit"
            @click.prevent="updatePromotion"
            :loading="loading"
            :disabled="loading || !validForm"
          >
            {{ $t("toSave") }}
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { validate } from "@/util/validate.js";

import AWS from "aws-sdk";
const bucketName = "sga-assets";
const bucketRegion = "sa-east-1";
const creds = new AWS.Credentials({
  accessKeyId: "accessKeyId",
  secretAccessKey: "secretAccessKey",
});

AWS.config.update({
  region: bucketRegion,
  credentials: creds,
});

const s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: bucketName },
});

const allowedMimes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
const MAX_IMAGE_SIZE = 2000000; // max. 2MB
const MAX_IMAGE_WIDTH = 1800;
const MAX_IMAGE_HEIGHT = 800;

export default {
  props: ["promotion"],
  data: () => ({
    dialog: false,
    loading: false,
    newPromotion: {
      title: "",
      description: "",
      hidePromotion: false,
    },
    currentImage: "",
    oldImage: "",
    imageLoaded: false,
    file: null,
    disableSave: false,
    rules: {
      required: validate.required,
    },
    updatingImage: false,
    validForm: false,
  }),

  computed: {
    operatorUrl() {
      try {
        let operatorUrl = this.$operator.url;
        if (operatorUrl.slice(-1) == "/") {
          operatorUrl = operatorUrl.slice(0, -1);
        }

        return operatorUrl;
      } catch (e) {
        return "";
      }
    },
    shouldHidePromotion() {
      return (
        this.promotion.type_promo == "deposito" ||
        this.promotion.type_promo == "1ºdeposito" ||
        this.promotion.type_promo == "cadastro"
      );
    },
  },

  watch: {
    file() {
      if (!allowedMimes.includes(this.file.type)) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("fileTypeNotAllowedImage"),
          color: "warning",
        });

        this.currentImage = this.oldImage;
        this.disableSave = true;
        return;
      }

      if (this.file.type > MAX_IMAGE_SIZE) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("imageTooLarge"),
          color: "warning",
        });

        this.currentImage = this.oldImage;
        this.disableSave = true;
        return;
      }

      this.disableSave = false;
    },
    dialog(val) {
      if (val) {
        this.oldImage = null;
        this.currentImage = null;
        this.newPromotion.title = this.promotion.title;
        this.newPromotion.description = this.promotion.descricao;
        this.newPromotion.hidePromotion = this.promotion.hide == 1;
        this.setCurrentImage();
      } else {
        this.loading = false;
      }
    },
  },

  methods: {
    async addImage(promotionUpdated) {
      this.updatingImage = true;

      if (this.oldImage) {
        const { db_name } = JSON.parse(localStorage.getItem("user_data"));

        const extension = this.oldImage.split(".")[
          this.oldImage.split(".").length - 1
        ];
        const Key = `domains/${db_name}/promotions/${this.promotion.code_promo}.${extension}`;

        s3.deleteObject({ Key }, () => {
          //   this.currentImage = null;

          let ext;

          switch (this.file.type) {
            case "image/png":
              ext = ".png";
              break;
            case "image/jpeg":
            case "image/jpg":
              ext = ".jpg";
              break;
            default:
              ext = ".png";
              break;
          }

          const { db_name } = JSON.parse(localStorage.getItem("user_data"));

          const domainImageKey = `domains/${db_name}/promotions/`;
          const newImageKey = domainImageKey + this.promotion.code_promo + ext;
          const upload = new AWS.S3.ManagedUpload({
            params: {
              Bucket: bucketName,
              Key: newImageKey,
              Body: this.file,
              ACL: "public-read",
            },
          });

          const _this = this;
          upload.promise().then((res) => {
            _this.updatingImage = false;

            _this.oldImage = res.Location;
            // this.currentImage = res.Location;

            if (!promotionUpdated) {
              _this.loading = false;
              _this.dialog = false;
            }

            if (_this.loading === true) {
              _this.dialog = false;
            }

            _this.$store.commit("setFeedbackSnack", {
              title: "Sucesso!",
              msg: _this.$t("loadImageSuccess"),
              color: "success",
            });
          });
        });
      }
    },
    setCurrentImage() {
      const { db_name } = JSON.parse(localStorage.getItem("user_data"));

      const promise = s3
        .listObjects({
          Prefix: `domains/${db_name}/promotions/`,
        })
        .promise();

      let _this = this;

      promise.then((data) => {
        const images = data.Contents.map((image) => {
          const imageUrl =
            `https://s3.sa-east-1.amazonaws.com/${bucketName}/` +
            encodeURIComponent(image.Key);

          return { imageUrl };
        });

        const image = images.find(({ imageUrl }) => {
          const splittedByDot = imageUrl.split(".")[
            imageUrl.split(".").length - 2
          ];

          const imageName = splittedByDot.split("%2F")[
            splittedByDot.split("%2F").length - 1
          ];

          return imageName === _this.promotion.code_promo;
        });

        if (image) {
          _this.oldImage = image.imageUrl;
          _this.currentImage = image.imageUrl;
        } else {
          _this.currentImage = null;
          _this.oldImage = null;
          _this.imageLoaded = false;
        }
      });
    },
    onFileChange(element) {
      this.image = null;

      let files = element.target.files || element.dataTransfer.files;
      if (!files.length) {
        this.$store.commit("setFeedbackSnack", {
          msg: this.$t("chooseAnImageFirst"),
          color: "warning",
        });
        return;
      }

      this.file = files[0];

      const _this = this;
      // Generate pre-view image UI
      let reader = new FileReader();
      reader.onload = (element) => {
        // validacao width x height da imagem
        let image = new Image();
        image.src = element.target.result;
        image.onload = function() {
          const height = this.height;
          const width = this.width;
          if (height > MAX_IMAGE_HEIGHT || width > MAX_IMAGE_WIDTH) {
            _this.$store.commit("setFeedbackSnack", {
              msg: _this.$t("warningMaxSize"),
              color: "warning",
            });

            _this.currentImage = _this.oldImage;
          }
        };

        if (!this.disableSave) {
          this.currentImage = element.target.result;
        }
      };

      reader.readAsDataURL(this.file);
    },
    loadImage() {
      this.$refs.image.click();
    },
    async updatePromotion() {
      const imageUpdated = this.currentImage !== this.oldImage;

      const newHideValue = this.newPromotion.hidePromotion ? "1" : "0";

      const promotionUpdated =
        this.newPromotion.title !== this.promotion.title ||
        this.newPromotion.description !== this.promotion.descricao ||
        this.promotion.hide !== newHideValue;

      if (imageUpdated || promotionUpdated) {
        this.loading = true;
      }

      if (imageUpdated) {
        await this.addImage(promotionUpdated);
      }

      if (promotionUpdated === false) {
        // this.loading = false;
        return;
      }

      this.$axios
        .post(
          "/administrator/promotions/editPromotion",
          this.$formdata({
            id_promo: this.promotion.id_promo,
            title: this.newPromotion.title.trim(),
            description: this.newPromotion.description.trim(),
            hide: this.newPromotion.hidePromotion ? 1 : 0,
          })
        )
        .then((res) => {
          if (this.updatingImage === false) {
            this.$store.commit("setFeedbackSnack", {
              msg: res.data.messages,
              color: "success",
            });

            this.$emit("refreshPromotions");

            this.dialog = false;
          }
        })
        .finally(() => {
          if (this.updatingImage === false) {
            this.loading = false;
          }
        });
    },
  },
};
</script>
